import { hydrate, prerender as ssr } from "preact-iso";
import { App } from "./app.tsx";

import "@fontsource/roboto";
import "@fontsource/silkscreen";
import "./index.css";

if (typeof window !== "undefined") {
    hydrate(<App />, document.getElementById("app")!);
}

// deno-lint-ignore no-explicit-any
export async function prerender(data: any) {
    const { html, links } = await ssr(<App />);
    return {
        html,
        links,
        data: { url: data.url },
        head: {
            lang: "es",
            title: "Servidorcito de Simx72",
            elements: new Set([
                /* {
                    type: "meta",
                    props: {
                        name: "description",
                        content: "This is a prerendered Preact app",
                    },
                }, */
            ]),
        },
    };
}
